export default __webpack_public_path__ + "static/media/check.8f4f78d2.svg";